import BlueprintComponent from '../core/blueprintComponent';
import '../../scss/components/image.scss';
/** The name of the module */
export const name = 'Image';
/** Class names for the component */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-image";
    ClassNames["JavaScript"] = "js-image";
})(ClassNames || (ClassNames = {}));
class Image extends BlueprintComponent {
    /**
     * Create an img HTML element
     *
     * @param imageAttributes HTML Image attributes
     */
    static createElement(imageAttributes) {
        const element = document.createElement('img');
        element.classList.add('bp-c-image');
        element.src = imageAttributes.src;
        if (imageAttributes.srcset) {
            element.srcset = imageAttributes.srcset;
        }
        if (imageAttributes.width) {
            element.width = imageAttributes.width;
        }
        if (imageAttributes.height) {
            element.height = imageAttributes.height;
        }
        return element;
    }
}
export default Image;
